import React, { useMemo } from 'react';
import { X, CopyIcon } from 'lucide-react';
import { FONT_UI } from '../../constants/design-tokens';
import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';
import { usePanels } from '../../shared/hooks/use-panels';

export const JSONPanel: React.FC = () => {
  const { canvas } = useEditorCanvas();
  const { isOpen, close } = usePanels();
  const open = isOpen('json');
  const data = useMemo(() => (open && canvas ? canvas.toJSON() : null), [open, canvas]);

  if (!data) return null;

  return (
    <div
      onClick={close}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 50
      }}
    >
      <div
        data-panel-id='json'
        onClick={e => e.stopPropagation()}
        style={{
          width: 520,
          maxWidth: '90vw',
          maxHeight: '80vh',
          backgroundColor: '#ffffff',
          borderRadius: 12,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.16)'
        }}
      >
        <div
          style={{
            padding: '16px 20px',
            borderBottom: '1px solid #e5e5e5',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: '#fafafa',
            flexShrink: 0
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <div style={{ fontSize: 14, fontWeight: 600, fontFamily: FONT_UI, color: '#171717' }}>
              JSON del Proyecto
            </div>
            <div style={{ fontSize: 11, fontFamily: FONT_UI, color: '#737373', marginTop: 2 }}>
              Estructura completa del banner
            </div>
          </div>

          <div style={{ display: 'flex', gap: 6 }}>
            <button
              onClick={() => navigator.clipboard.writeText(JSON.stringify(data, null, 2))}
              style={{
                padding: '6px 12px',
                background: '#171717',
                border: 'none',
                borderRadius: 6,
                color: '#ffffff',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                transition: 'background 0.15s'
              }}
              onMouseEnter={e => (e.currentTarget.style.background = '#404040')}
              onMouseLeave={e => (e.currentTarget.style.background = '#171717')}
            >
              <CopyIcon size={14} />
            </button>
            <button
              onClick={close}
              style={{
                padding: '6px 12px',
                background: '#ffffff',
                border: '1px solid #e5e5e5',
                borderRadius: 6,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                transition: 'background 0.15s'
              }}
              onMouseEnter={e => (e.currentTarget.style.background = '#f5f5f5')}
              onMouseLeave={e => (e.currentTarget.style.background = '#ffffff')}
            >
              <X size={14} />
            </button>
          </div>
        </div>

        <pre
          style={{
            flex: 1,
            margin: 0,
            padding: 20,
            fontSize: 12,
            fontFamily: "'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, monospace",
            color: '#171717',
            whiteSpace: 'pre-wrap',
            overflow: 'auto',
            backgroundColor: '#fafafa',
            lineHeight: 1.6,
            textAlign: 'left'
          }}
        >
          {JSON.stringify(data, null, 2)}
        </pre>
      </div>
    </div>
  );
};
